import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../node_modules/slick-carousel/slick/slick.css';

Vue.config.productionTip = false

// APIs
import axios from 'axios'

const apiInstance   = axios.create({ baseURL: process.env.VUE_APP_API })
const telusInstance = axios.create({ baseURL: process.env.VUE_APP_TELUS })
telusInstance.defaults.headers.common = { 'Content-Type': 'application/x-www-form-urlencoded' }
window.api   = apiInstance
window.telus = telusInstance

// API Log Interceptors
const apiWhiteList = ['/api/preinscription', '/api/popup-form', '/api/new-account']
axios.interceptors.response.use(
  response => {
    const functionName = response.config.url.split('/admin/public')[1]
    const args = response.config.data ? JSON.parse(response.config.data) : ''
    if (apiWhiteList.includes(functionName)) {
      const logData = {
        nom              : args.lastname,
        prenom           : args.firstname,
        tel              : args.phone,
        model            : args.model,
        version          : args.version ? args.version : '',
        apportMensualite : args.mensualite ? args.mensualite.input.apport : '',
        dureeMensualite  : args.mensualite ? args.mensualite.input.duree : '',
        typeMensualite   : args.mensualite ? args.mensualite.type : '',
        formuleMensualite: args.mensualite ? args.mensualite.formule : '',
        mensualite       : args.mensualite ? args.mensualite.output.mensualite_all_inclusive : '',
        args             : JSON.stringify(args),
        result           : response.data,
        function         : functionName,
        code             : response.status
      }
      axios.post('https://succursalesrenault.ma/onlinestore/admin/public/api/log', logData)
        .catch(err => console.error(err))
    }
    return response
  },
  function axiosRetryInterceptor(err) {
    const functionName = err.response.config.url.split('/admin/public')[1]
    const args = err.response.config.data ? JSON.parse(err.response.config.data) : ''
    if (apiWhiteList.includes(functionName)) {
      const logData = {
        nom              : args.lastname ? args.lastname : '',
        prenom           : args.firstname ? args.firstname : '',
        tel              : args.phone ? args.phone : '',
        model            : args.model ? args.model : '',
        version          : args.version ? args.version : '',
        apportMensualite : args.mensualite ? args.mensualite.input.apport : '',
        dureeMensualite  : args.mensualite ? args.mensualite.input.duree : '',
        typeMensualite   : args.mensualite ? args.mensualite.type : '',
        formuleMensualite: args.mensualite ? args.mensualite.formule : '',
        mensualite       : args.mensualite ? args.mensualite.output.mensualite_all_inclusive : '',
        args             : args ? JSON.stringify(args) : '',
        result           : err.response.data.message ? err.response.data.message : err.response.data,
        function         : functionName,
        code             : err.response.status
      }
      axios.post('https://succursalesrenault.ma/onlinestore/admin/public/api/log', logData)
        .catch(err => console.error(err))
    }
  },
  error => Promise.reject(error)
)

// Mixin
import mixin from './mixin'
Vue.mixin(mixin)

// BEM
import { bemPlugin } from 'vue-simple-bem'
Vue.use(bemPlugin)

// Collapse
import VueCollapse from 'vue2-collapse'
Vue.use(VueCollapse)

// Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key   : process.env.VUE_APP_GOOGLE_API_KEY,
    region: 'MA'
  },
  installComponents: false
})
Vue.component('GmapMarker', VueGoogleMaps.Marker)
Vue.component('GmapMap', VueGoogleMaps.Map)

// Custom scrollbar
import Vuebar from 'vuebar'
Vue.use(Vuebar)

// Custom select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('v-select', vSelect)

// Multi-lang
import i18n from './i18n'
Vue.component('localized-link', () => import('./components/LocalizedLink'))

// vue-inline-svg
import { InlineSvgPlugin } from 'vue-inline-svg'
Vue.use(InlineSvgPlugin)

// VueThreeSixty
import VueThreeSixty from 'vue-360'
import 'vue-360/dist/css/style.css'
Vue.use(VueThreeSixty)

// VueEasyLightbox
import VueEasyLightbox from 'vue-easy-lightbox'
Vue.use(VueEasyLightbox)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
